export enum BandedRowMode {
  Even = 'EVEN',
  Odd = 'ODD',
  Off = ''
}
